import { observable, action, computed, useStrict } from 'mobx';
import {setLocalStorage, getFromLocalStorage} from '../libs/localStorage';

class UiStore {
  
  @observable isNavOpen = getFromLocalStorage('isNavOpen') !== false;
  @observable windowWidth = window.innerWidth;
  
  @computed get mobileView() {
    return this.windowWidth < 900;
  }
  
  @computed get navWidth() {
    return this.isNavOpen ? '300px' : '0px';
  }

  constructor() {
    window.addEventListener('resize', () => this.windowWidth = window.innerWidth);
    if(this.mobileView && this.isNavOpen) this.toggleNav();
  }

  @action toggleNav() {
    this.isNavOpen = !this.isNavOpen;
    setLocalStorage('isNavOpen', this.isNavOpen);
  }
  
}

export default UiStore;



// WEBPACK FOOTER //
// ./src/stores/UiStore.js